import {FerryModel} from "../../dictionaries/models/ferry";
import {WharfModel} from "../../topology/models/wharf";
import {RouteModel} from "../../topology/models/route";
import {PortModel} from "../../dictionaries/models/ports";

export interface TimetableModel {
    availableWharfs: string[];
    timetableDays: TimetableDaysModel[];
    startWeek: string;
    endWeek: string;
}

export interface WeekAndYearModel {
    year: number;
    week: number;
}

export interface NumberOfWeeksModel {
    numberOfWeeks: number;
}

export interface TimetableDaysModel {
    dayDate: string;
    timetableActions: SimpleTimetableActionModel[];
}

export interface SimpleTimetableActionModel {
    ferryName: string;
    wharfName: string;
    actionType: TimetableActionTypes;
    plannedStartTime: string | null;
    plannedEndTime: string | null;
    id: string;
    notes: string;
    canceled: boolean;
    hasOrderRegistered: boolean;
}

export interface NewTimetableActionsModel {
    actions: NewTimetableActionModel[];
}

export interface NewTimetableActionModel {
    ferryId: string,
    actionType: TimetableActionTypes;
    voyageNo?: string;
    wharfId: string;
    notes: string;
    arrivalTime: Date | null | string;
    departureTime: Date | null | string;
    actualArrivalTime?: Date | null | string;
    actualDepartureTime?: Date | null | string;
    routes?: string[] | null;
    openParkingTime?: Date | null | string;
    startLoadingTime?: Date | null | string;
    endLoadingTime?: Date | null | string;
    destinationPortId?: string;
}

export interface ModifyTimetableActionModel {
    action: NewTimetableActionModel;
}

export interface CopySelectedWeekData {
    yearToCopy: number;
    weekToCopy: number;
    yearCopyFrom: number;
    weekCopyFrom: number;
}

export interface TimetableActionModel {
    ferry: FerryModel;
    actionType: TimetableActionTypes;
    voyageNo: string;
    wharf: WharfModel;
    notes?: string;
    arrivalTime: Date | null;
    departureTime: Date | null;
    actualArrivalTime?: Date | null;
    actualDepartureTime?: Date | null;
    routes?: RouteModel[];
    openParkingTime?: Date | null;
    startLoadingTime?: Date | null;
    endLoadingTime?: Date | null;
    destinationPort?: PortModel;
    id: string;
    hasOrderRegistered: boolean;
}

export enum TimetableActionTypes {
    ARRIVAL = "ARRIVAL",
    STOP = "STOP",
    DEPARTURE = "DEPARTURE"
}

export enum TimetableActionTypesFirstLetter {
    ARRIVAL = "I",
    STOP = "P",
    DEPARTURE = "E"
}

export interface TimetableDayWithRowsModel {
    dayName: string;
    rows: JSX.Element[][];
}

export enum TimetableFileFormat {
    json = "json",
    xls = "xls"
}
